"use strict";

class PropertyVisitorAppointmentSettingsController {

    constructor($parse, $timeout, SSHttpService, SSUtilService, SSDateService, SSAlertService, SSUserService, OTPService, SSConfirmationService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.getPropertySettings();
        
        // Disable past date selection
        $('.date-input').datepicker({ minDate: new Date() });
    }


    // ----------- GENERAL SETTINGS SECTION  -------

    getPropertySettings() {
        const self = this;

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_settings){

                // Get Visitor Appointment Settings
                self.appointment_settings = self.getSetting(response.data.property_settings, 'visitor_appointment_settings');

                if(self.appointment_settings){

                    if(self.appointment_settings.value && self.appointment_settings.value.blackout_days){
                        $.each(self.appointment_settings.value.blackout_days, function(index, blackout_day){
                            if(blackout_day.date){
                                /** WEB-4312: tolerate a day-first stored date instead of turning it into "Invalid date". */
                                blackout_day.date = self.SSDateService.formatSettingsDateAsDayFirst(blackout_day.date);
                            }
                            if(blackout_day.start_time && blackout_day.end_time){
                                blackout_day.start_time = (moment.utc(blackout_day.start_time, 'HH:mm')).local().format('HH:mm');
                                blackout_day.end_time = (moment.utc(blackout_day.end_time, 'HH:mm')).local().format('HH:mm');
                            }
                        });
                    }

                    if(self.appointment_settings.value && self.appointment_settings.value.slot_times){
                        $.each(self.appointment_settings.value.slot_times, function(index, slot){
                            if(slot.start_time && slot.end_time){
                                slot.start_time = (moment.utc(slot.start_time, 'HH:mm')).local().format('HH:mm');
                                slot.end_time = (moment.utc(slot.end_time, 'HH:mm')).local().format('HH:mm');
                            }
                        });
                    }
                }
                else{
                    self.appointment_settings = self.getDefaultSettings();
                }

                /**
                 * WEB-3540: every map sub-key must always be a map ({}) — never an array ([]).
                 * Empty maps can be persisted as [] (legacy data / PHP json_encode), and because []
                 * is truthy in JS the falsy-only guards miss it; a later dot-assignment is then
                 * dropped by JSON.stringify (silent data loss). Normalise on load so the edit / save
                 * paths cannot drift (extends the WEB-3538 key_handover fix to visitor settings).
                 */
                self.normalizeMapSettings(self.appointment_settings.value);
            }
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    // ---------  Visitor Appointment Settings Section  -------

    editAppointmentSettings(editMode){
        const self = this;

        self.appointmentSettingsParams = {};
        self.appointmentSettingsErrors = {};

        if(editMode){
            if(self.appointment_settings){
                self.appointmentSettingsParams = angular.copy(self.appointment_settings);

                /** WEB-3540: keep every map sub-key as {} (never []) in the edit buffer */
                self.normalizeMapSettings(self.appointmentSettingsParams.value);

                // If 'slot_times' are empty then initialize with default data
                if(!self.appointmentSettingsParams.value.slot_times){
                    self.appointmentSettingsParams.value.slot_times = [];
                    self.appointmentSettingsParams.value.slot_times.push({start_time: null, end_time: null});
                }
                // If 'blackout_days' are empty then initialize with default data
                if(!self.appointmentSettingsParams.value.blackout_days){
                    self.appointmentSettingsParams.value.blackout_days = [];
                    self.appointmentSettingsParams.value.blackout_days.push({date: null, start_time: null, end_time: null});
                }
            }
            else{
                self.appointmentSettingsParams = self.getDefaultSettings();
            }
        }

        // Minimum slot period is 60 minutes
        if(self.appointmentSettingsParams.value && !self.appointmentSettingsParams.value.slot_period){
            self.appointmentSettingsParams.value.slot_period = 60;
        }

        self.appointmentSettingsEditMode = editMode;
    }

    saveAppointmentSettings(){
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._saveAppointmentSettings();
        });
    }

    _saveAppointmentSettings(){
        const self = this;

        if(!self.isValidAppointmentSettingInput()){
            return;
        }

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        let params = self.getAppointmentSettingsParams();

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Visitor appointment settings updated successfully.');
            self.appointmentSettingsEditMode = false;
            self.getPropertySettings();
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
    }

    isValidAppointmentSettingInput(){
        const self = this;

        self.appointmentSettingsErrors = {};

        let params = self.appointmentSettingsParams.value;
        let isValid = true;

         if(!params.number_of_tables){
            self.appointmentSettingsErrors.number_of_tables = "Please enter no. of tables";
            isValid = false;
        }
        if(!params.number_of_persons_per_table){
            self.appointmentSettingsErrors.number_of_persons_per_table = "Please enter no. of persons";
            isValid = false;
        }
        if(!params.slot_period){
            self.appointmentSettingsErrors.slot_period = "Please enter slot period";
            isValid = false;
        }
        else if(params.slot_period && parseInt(params.slot_period) < 30){
            self.appointmentSettingsErrors.slot_period = "Minimum slot period is 30 minutes.";
            isValid = false;
        }
        if(!params.max_appointment_days){
            self.appointmentSettingsErrors.max_appointment_days = "Please enter max. appointment days";
            isValid = false;
        }

        self.appointmentSettingsErrors.slot_times = {};

        // User must provide at least one slot time
        $.each(params.slot_times, function(index, slot){
            self.appointmentSettingsErrors.slot_times[index] = {};
            if(!slot.start_time){
                self.appointmentSettingsErrors.slot_times[index].start_time = "Please enter start time.";
                isValid = false;
            }
            if(!slot.end_time){
                self.appointmentSettingsErrors.slot_times[index].end_time = "Please enter end time."
                isValid = false;
            }

            // end_time must be greater than start_time
            if(slot.start_time && slot.end_time && moment(slot.start_time, 'HH:mm') >= moment(slot.end_time, 'HH:mm')){
                self.appointmentSettingsErrors.slot_times[index].start_time = "End time must be greater than start time.";
                isValid = false;
            }
        });

        return isValid;
    }

    getDefaultSettings(){
        const self = this;

        // Default 'availability_settings' is 'developer_staff: true'
        let settings = { 
            name: 'visitor_appointment_settings', 
            value: { slot_times:[], blackout_days:[], availability_settings: {developer_staff: true} }
        };
        settings.value.slot_times.push({start_time: null, end_time: null});
        settings.value.blackout_days.push({date: null, start_time: null, end_time: null});

        return settings;
    }

    /**
     * WEB-3540: Coerce every map-type sub-key of visitor_appointment_settings to a plain object ({}).
     *
     * @remarks
     * property_settings.value is persisted as a raw string (no JSON cast on the BE), so the shape the
     * FE serialises is exactly what is read back. An empty associative structure can be stored as []
     * (legacy data / PHP json_encode), and because [] is truthy in JS the falsy-only guards leave it
     * in place — flipping the shape between [] and {} and risking silent data loss (JSON.stringify
     * drops keys assigned to an array). Calling this at every load / edit / save boundary keeps the
     * three sites from drifting (extends the WEB-3538 key_handover fix). Genuine list fields
     * (slot_times, blackout_days) and scalars (number_of_tables, slot_period, ...) are NOT touched.
     *
     * @param {Object} value - The visitor_appointment_settings `value` object to normalise (mutated in place).
     * @returns {Object} The same `value` object, for chaining.
     */
    normalizeMapSettings(value){
        if(!value) return value;

        let mapFields = [
            'availability_settings'
        ];

        $.each(mapFields, function(index, field){
            if(!value[field] || Array.isArray(value[field])){
                value[field] = {};
            }
        });

        return value;
    }

    getAppointmentSettingsParams(){
        const self = this;

        /** WEB-3540: final safety net — never serialise any map sub-key as [] */
        self.normalizeMapSettings(self.appointmentSettingsParams.value);

        if(self.appointmentSettingsParams.value.slot_times){

            $.each(self.appointmentSettingsParams.value.slot_times, function(index, slot){

                slot.start_time = moment(moment(slot.start_time, "HH:mm")).utc().format("HH:mm");
                slot.end_time = moment(moment(slot.end_time, "HH:mm")).utc().format("HH:mm");
            });
        }

        if(self.appointmentSettingsParams.value.blackout_days){

            $.each(self.appointmentSettingsParams.value.blackout_days, function(index, blackout_day){

                if(blackout_day.date){
                    blackout_day.date = self.SSDateService.formateWithTimeAsNoon(blackout_day.date);

                    if(blackout_day.start_time && blackout_day.end_time){
                        blackout_day.start_time = moment(moment(blackout_day.start_time, "HH:mm")).utc().format("HH:mm");
                        blackout_day.end_time = moment(moment(blackout_day.end_time, "HH:mm")).utc().format("HH:mm");
                    }
                }
            });
        }

        let params = { 
            id: self.appointmentSettingsParams.id? self.appointmentSettingsParams.id : 0, 
            name: 'visitor_appointment_settings', 
            value: JSON.stringify(self.appointmentSettingsParams.value) 
        };
        
        return params;
    }

    addAppointmentSlot(){
        const self = this;

        self.appointmentSettingsParams.value.slot_times.push({
            start_time: null, end_time: null
        });
    }

    removeAppointmentSlot(index){
        const self = this;

        if(self.appointmentSettingsParams.value.slot_times.length > 1){
            self.appointmentSettingsParams.value.slot_times.pop();
        }
    }

    addBlackoutDay(){
        const self = this;

        self.appointmentSettingsParams.value.blackout_days.push({
            date: null, start_time: null, end_time: null
        });
    }

    removeBlackoutDay(index){
        const self = this;

        if(self.appointmentSettingsParams.value.blackout_days.length > 1){
            self.appointmentSettingsParams.value.blackout_days.pop();
        }
    }

    // ---------  END: Visitor Appointment Settings Section  -------

}

PropertyVisitorAppointmentSettingsController.$inject = ['$parse', '$timeout', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', 'SSUserService', 'OTPService', 'SSConfirmationService'];
app.controller('PropertyVisitorAppointmentSettingsController', PropertyVisitorAppointmentSettingsController);

// WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js (services.js is
// loaded on every page). A copy here would link it a second time on every element.

app.directive("timepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "timepicker()" METHOD USING THE "element" OBJECT.
        element.timepicker();
    }

    return {
        require: 'ngModel',
        link: link
    };
});

